import { render, staticRenderFns } from "./PieApiAuthor.vue?vue&type=template&id=62865daa"
import script from "./PieApiAuthor.vue?vue&type=script&lang=ts"
export * from "./PieApiAuthor.vue?vue&type=script&lang=ts"
import style0 from "./PieApiAuthor.vue?vue&type=style&index=0&id=62865daa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports